import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import Paper from '@material-ui/core/Paper'
import {LocationOn, TrendingUp, StarOutline} from '@material-ui/icons'
import {DomainList} from './TextComponents'

const Card = styled(Paper).attrs(() => ({
	elevation: 4,
}))`
	height: 354px;
	@media (max-width: 600px) {
		height: auto;
	}
	&.MuiPaper-rounded {
		border-radius: 8px;
	}
	// padding: 16px;
	overflow: hidden;

	.project-title {
		font-weight: bold;
		font-size: 16px;
		// color: rgba(0, 0, 0, 0.7);
		margin-top: 12px;
	}

	.project-initiated {
		font-size: 12px;
		font-weight: bold;
		// color: rgba(0, 0, 0, 0.5);
	}

	.project-info {
		font-size: 14px;
		font-weight: 600;
		// color: rgba(0, 0, 0, 0.7);
		margin-top: 20px;
		.MuiSvgIcon-fontSizeSmall {
			font-size: 14px;
		}
		display: grid;
		grid-template-columns: 1fr 2fr;
	}

	.project-summary {
		font-size: 14px;
		line-height: 20px;
		// color: rgba(0, 0, 0, 0.7);
		margin-top: 6px;
		// height: calc(5 * 20px);
		display: -webkit-box;
		-webkit-line-clamp: 4; /* Limit to 4 lines */
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: pre-line;
	}

	/* Make layout breathe on small screens */
	@media (max-width: 600px) {
		// padding: 12px;
		.project-info {
			grid-template-columns: 1fr;
			row-gap: 8px;
		}
	}
`

const Media = styled.div`
	width: 100%;
	border-radius: ' 8px 8px 0 0';
	overflow: hidden;
	background: #f3f3f3;
	// z-index: 0;
	background: #2a7b9b;
	background: linear-gradient(
		140deg,
		rgba(42, 123, 155, 1) 0%,
		rgba(87, 199, 133, 1) 50%,
		rgba(237, 221, 83, 1) 100%
	);
	.flexContainer {
		display: flex;
		justify-content: space-between;
	}
	.logoContainer {
		height: 70px;
		width: 70px;
		overflow: hidden;
		border-radius: 8px;
		border: 4px solid white;
		background-color: white;
		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}
	.project-location,
	.project-status,
	.iLab {
		background-color: white;
		padding: 2px 8px;
		border-radius: 12px;
		font-weight: 600;
		border: 1px solid #3e66cc;
		display: flex;
		align-items: center;
		color: #3e66cc;
		font-size: 12px;
	}
	.flex {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		padding: 16px;
		height: 142px;
	}
`

const SmallDomainList = styled(DomainList).attrs(() => ({
	fontSize: '12px',
}))`
	margin: 8px 0 0 0;
	@media (max-width: 600px) {
		height: auto;
	}
	.domain {
		background-color: #f3f4f6;
		border-radius: 12px;
		padding: 4px 12px;
		color: #565d6d;
	}
`
const ProjectSummaryCard = ({projectData}) => {
	const {
		projectName,
		yearInitiated,
		primaryPathway,
		citiesOfOperation,
		projectStatus,
		legacy,
		projectSummary,
		// iLab,
		logoImage,
		groupPhoto,
	} = projectData

	let imageToShow = logoImage || groupPhoto || '/TFI_logo.png'

	return (
		<Card>
			<Media aria-label={`${projectName || 'Project'} image`}>
				<div className="flex">
					<div className="flexContainer">
						<div className="logoContainer">
							{imageToShow && (
								<img
									src={imageToShow}
									alt={`${projectName || 'Project'} logo`}
									loading="lazy"
								/>
							)}
						</div>
						<div>
							<div className="project-location">
								<LocationOn fontSize="small" />
								{Array.isArray(citiesOfOperation)
									? citiesOfOperation[0]
									: citiesOfOperation}
							</div>
							<div
								style={{
									fontWeight: 'bold',
									fontSize: '14px',
									color: 'white',
									textAlign: 'right',
									padding: '8px 10px 0px 0px',
								}}
							>
								{yearInitiated}
							</div>
						</div>
					</div>
					<div className="flexContainer end">
						<div className="project-status">
							<TrendingUp
								fontSize="small"
								style={{paddingRight: '2px'}}
							/>
							{legacy
								? `${projectStatus} , ${legacy}`
								: projectStatus}
						</div>

						{/* {iLab && (
							<div className="iLab">
								<StarOutline fontSize="small" />
								iLab Project
							</div>
						)} */}
					</div>
				</div>
			</Media>
			<div style={{padding: '0px 16px 16px 16px'}}>
				<div className="project-title">{projectName}</div>
				{/* <div className="project-initiated">{yearInitiated}</div> */}
				<SmallDomainList>
					{/* {pathways &&
						pathways.map(domain => (
							<div className="domain" key={domain}>
								{domain}
							</div>
						))} */}
					{/* <div className="domainContainer"> */}
					<div className="domain">{primaryPathway}</div>
					{/* </div> */}
				</SmallDomainList>
				{/* <div
					className="project-info"
					style={{display: 'flex', justifyContent: 'space-between'}}
				>
					<div className="project-location">
						<LocationOn fontSize="small" />{' '}
						{Array.isArray(citiesOfOperation)
							? citiesOfOperation[0]
							: citiesOfOperation}
					</div>
					<div className="project-status">
						<TrendingUp fontSize="small" />{' '}
						{legacy
							? `${projectStatus} , ${legacy}`
							: projectStatus}
					</div>
					{iLab && (
						<div
							style={{
								display: 'flex',
								justifyContent: 'space-between',
								gap: 4,
							}}
						>
							<StarOutline />
							iLab Project
						</div>
					)}
				</div> */}
				<div className="project-summary">{projectSummary}</div>
			</div>
		</Card>
	)
}

ProjectSummaryCard.propTypes = {
	/** The project data to show in the card */
	projectData: PropTypes.shape({
		projectName: PropTypes.string,
		yearInitiated: PropTypes.string,
		primaryPathway: PropTypes.string,
		pathways: PropTypes.arrayOf(PropTypes.string),
		citiesOfOperation: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.arrayOf(PropTypes.string),
		]),
		projectSummary: PropTypes.string,
		projectStatus: PropTypes.string,
		legacy: PropTypes.string,
	}).isRequired,
}

export default ProjectSummaryCard
